import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useAdSurfaceAndSlot } from '../../hooks/useAdSurfaceAndSlot';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import {
  InlineRoot,
  Thumb,
  Body,
  TopRow,
  AdTag,
  Sponsor,
  Title,
  Desc,
  CtaDesktop,
} from './AdInline.styled';

export default function AdInline({ ad, pageKey, onLinkClick }) {
  const { loaded, slotVisible } = useAdSurfaceAndSlot(pageKey);
  if (!loaded || !slotVisible || !ad?.image) return null;

  const dest = isValidAdDestination(ad.url);
  const href = dest ? ad.url : '#';
  const onClick = (e) => {
    if (!dest) e.preventDefault();
    else onLinkClick?.(e);
  };

  return (
    <InlineRoot
      href={href}
      onClick={onClick}
      target={dest ? '_blank' : undefined}
      rel={dest ? 'noopener noreferrer sponsored' : undefined}
    >
      <Thumb>
        <img src={ad.image} alt="" loading="lazy" />
      </Thumb>
      <Body>
        <TopRow>
          <AdTag>Ad</AdTag>
          <Sponsor>{ad.sponsor}</Sponsor>
        </TopRow>
        <Title>{ad.title}</Title>
        <Desc>{ad.description}</Desc>
      </Body>
      <CtaDesktop>
        {ad.cta} <ExternalLink size={10} />
      </CtaDesktop>
    </InlineRoot>
  );
}
